<template>
  <so-button
    class="pill"
    variant="red"
    :no-shadow="noShadow"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <img src="@/assets/images/icn_back_to_app.svg" alt class="icon" />
    <span>{{ $t('selfcheck.smartphoneOrderFinished') }}</span>
  </so-button>
</template>

<script>
import SoButton from '@/components/common/SoButton'

export default {
  name: 'SoQuitButton',
  components: {
    SoButton,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
    },
    noShadow: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.icon {
  width: 18px;
  height: 18px;
  color: #fff;
  margin: -5px 8px 0 0;
}
</style>
